<div class="image-upload-container">
  <button class="close" mat-icon-button (click)="onNoClick()">
    <mat-icon>close</mat-icon>
  </button>
  <h3>{{ 'Upload Image' | translate }}</h3>
  <input type="file" #inpFile (change)="fileChangeEvent($event)" class="dnone"
    accept="image/png, image/jpeg, image/jpg" />

  <image-cropper *ngIf="imageChangedEvent" [imageChangedEvent]="imageChangedEvent" [aspectRatio]="aspectRatio"
    [maintainAspectRatio]="true" [containWithinAspectRatio]="true" (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"
  [resizeToWidth]="resizedWidth" format="png">
  </image-cropper>

  <div *ngIf="!imageChangedEvent && !initialImage" class="bg-card outline-box outline background-5 dragOver"
    [ngClass]="{'dragOver': dragOver}" (drop)="onDropFile($event)" (dragover)="onDragOverFile($event)"
    (dragleave)="onDragLeaveFile()" (click)="inpFile.click()">
    <span class="text">
      <mat-icon>cloud_upload</mat-icon>
      <span class="title" [class.animate]="dragOver">
        {{ dragOver ? ('DROP_HERE' | translate) : ('DRAG_DROP_FILES' | translate) }}
      </span>
      <ng-container *ngIf="!dragOver">
        <span class="or">{{ 'or' | translate }}</span>
        <span class="sub-title primary">{{ 'Browse your file' | translate }}</span>
      </ng-container>
    </span>
  </div>

  <div *ngIf="!imageChangedEvent && initialImage" class="image-preview">
    <img [src]="initialImage" alt="Initial Image" class="border rounded shadow" width="100%" />
    <button mat-button color="primary" (click)="inpFile.click()">
      {{ 'Change Image' | translate }}
    </button>
    <button mat-button color="warn" (click)="removeImage()">
      {{ 'Remove Image' | translate }}
    </button>
  </div>

  <div class="row">
    <div class="col-6">
      <a mat-flat-button color="primary" [mat-dialog-close]="data.croppedImage" cdkFocusInitial>{{ 'Save' | translate
        }}</a>
      <a *ngIf="imageChangedEvent" class="ml-2" mat-button (click)="inpFile.click()">{{ 'Change' | translate }}</a>
    </div>
  </div>
</div>